var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 24,
    viewBox: "0 0 54 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 53,
    height: 23,
    rx: 11.5,
    fill: "#E38006",
    stroke: "#303030"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 12,
    r: 8.5,
    fill: "white",
    stroke: "#303030"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0742 11.8164C13.0742 10.3906 13.457 9.27539 14.2227 8.4707C14.9883 7.66211 15.9766 7.25781 17.1875 7.25781C17.9805 7.25781 18.6953 7.44727 19.332 7.82617C19.9688 8.20508 20.4531 8.73438 20.7852 9.41406C21.1211 10.0898 21.2891 10.8574 21.2891 11.7168C21.2891 12.5879 21.1133 13.3672 20.7617 14.0547C20.4102 14.7422 19.9121 15.2637 19.2676 15.6191C18.623 15.9707 17.9277 16.1465 17.1816 16.1465C16.373 16.1465 15.6504 15.9512 15.0137 15.5605C14.377 15.1699 13.8945 14.6367 13.5664 13.9609C13.2383 13.2852 13.0742 12.5703 13.0742 11.8164ZM14.2461 11.834C14.2461 12.8691 14.5234 13.6855 15.0781 14.2832C15.6367 14.877 16.3359 15.1738 17.1758 15.1738C18.0312 15.1738 18.7344 14.873 19.2852 14.2715C19.8398 13.6699 20.1172 12.8164 20.1172 11.7109C20.1172 11.0117 19.998 10.4023 19.7598 9.88281C19.5254 9.35938 19.1797 8.95508 18.7227 8.66992C18.2695 8.38086 17.7598 8.23633 17.1934 8.23633C16.3887 8.23633 15.6953 8.51367 15.1133 9.06836C14.5352 9.61914 14.2461 10.541 14.2461 11.834ZM22.748 16V7.41016H23.9141L28.4258 14.1543V7.41016H29.5156V16H28.3496L23.8379 9.25V16H22.748Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOn);
export default __webpack_public_path__ + "static/media/on.49a391b170a23754a8a2566793d0227e.svg";
export { ForwardRef as ReactComponent };